import { render, staticRenderFns } from "./MyProfileView.vue?vue&type=template&id=8dcb8df6&"
import script from "./MyProfileView.vue?vue&type=script&lang=ts&"
export * from "./MyProfileView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports